__turbopack_context__.v({
  "colourFilterDropdownContents": "KTfy-a_colourFilterDropdownContents",
  "colourFilterDropdownOptionContainer": "KTfy-a_colourFilterDropdownOptionContainer",
  "colourFilterDropdownOptionLabel": "KTfy-a_colourFilterDropdownOptionLabel",
});
